import React, { useEffect, useState } from "react"
import { GiftCard } from "./GiftCard"
import search from "../../assets/search.svg"
import DashboardNavbar from "../../components/Navbar/DashboardNavbar"
import { getOrders } from "../../utils/ApiRequests"
import { useCart } from "react-use-cart"
import jblSpeaker from "../../assets/jbl-speaker.png"
import { useHistory } from "react-router-dom"

const GiftTracker = () => {
  const [orders, setOrders] = useState([])

  const history = useHistory()

  useEffect(() => {
    const abortController = new AbortController()

    const fetchData = async () => {
      try {
        const { data } = await getOrders()
        console.log(data.data)
        setOrders(data?.data)
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.log(error.response)
        }
      }
    }

    fetchData()
    return () => {
      abortController.abort()
    }
  }, [])

  return (
    <>
      <DashboardNavbar />
      <div className="global-container py-20 my-10">
        <div className="header text-black my-5 font-light">
          <h1 className="text-3xl font-semibold my-3">Gift Tracker</h1>
          <p className="text-gray-400 mb-3">
            We’ll list all gifts guests buy you on this page and on your app.
            Here’s a rundown on how to get them home.
          </p>
        </div>

        <div className="gift-card-lists mt-10">
          <div className="cards-select-wrapper">
            <div className=" select-header flex py-5 justify-between"></div>
          </div>
          {orders
            ?.slice()
            .reverse()
            .map(item => {
              return (
                <GiftCard
                  buyer={item.buyer}
                  orderId={item._id}
                  cartItems={item.cart}
                  totalCost={item.total_cost}
                  orderType={item.order_type}
                />
              )
            })}
        </div>
      </div>
    </>
  )
}

export default GiftTracker
